import { AnimatePresence } from 'motion/react';
import React from 'react';

import { dimmerAnimation } from '../../animation/dimmerAnimation';

import { BackgroundDimmerNaked } from './BackgroundDimmer.styles';

interface BackgroundDimmerProps {
  isOpen?: boolean;
  onClick?: () => void;
  zIndex?: number;
  opacity?: number;
}

export default function BackgroundDimmer({
  isOpen = false,
  onClick,
  zIndex = 3,
  opacity = 0.8,
}: BackgroundDimmerProps): React.ReactElement {
  return (
    <AnimatePresence>
      {isOpen && (
        <BackgroundDimmerNaked
          onClick={onClick}
          $zIndex={zIndex}
          $opacity={opacity}
          {...dimmerAnimation}
        />
      )}
    </AnimatePresence>
  );
}
